<template>
  <div class="main-panel">
    <div class="content-wrapper producto-shell">
      <div class="producto-card">
        <div class="producto-header">
          <div>
            <h3 class="mb-1">Nuevo Producto</h3>
            <p class="mb-0">Configura el producto siguiendo el flujo de negocio definido.</p>
          </div>
          <div class="d-flex gap-2 flex-wrap">
            <router-link to="/productos" class="btn btn-light">Regresar</router-link>
            <button
              type="button"
              class="btn btn-primary text-white"
              :disabled="saving || (isEditMode && !isAdmin)"
              @click="guardarProducto"
            >
              {{ actionButtonText }}
            </button>
          </div>
        </div>

        <form class="producto-form" @submit.prevent="guardarProducto">
          <fieldset :disabled="isEditMode && !isAdmin">
          <div class="section-block">
            <h5 class="section-title">Datos generales</h5>
            <div class="form-grid">
              <div class="form-field">
                <label>Nombre</label>
                <input v-model="producto.nombre" type="text" class="form-control input-pad" required>
              </div>
              <div class="form-field">
                <label>Descripción</label>
                <input v-model="producto.descripcion" type="text" class="form-control input-pad" required>
              </div>
              <div class="form-field switch-field">
                <label>Activo</label>
                <input v-model="producto.activo" type="checkbox" class="form-check-input">
              </div>
            </div>
          </div>

          <div class="section-block">
            <h5 class="section-title">Monto</h5>
            <div class="form-grid">
              <div v-if="!producto.montoLimiteActivo" class="form-field switch-field">
                <label>Monto fijo</label>
                <input v-model="producto.montoFijo" type="checkbox" class="form-check-input" @change="handleMontoFijoChange">
              </div>
              <div v-if="!producto.montoFijo" class="form-field switch-field">
                <label>Monto límite activo</label>
                <input v-model="producto.montoLimiteActivo" type="checkbox" class="form-check-input" @change="handleMontoLimiteChange">
              </div>
              <div v-if="producto.montoFijo" class="form-field">
                <label>Monto fijo valor</label>
                <input
                  v-model.number="producto.montoFijoValue"
                  type="number"
                  step="any"
                  min="0.01"
                  class="form-control input-pad"
                  :class="{ 'is-invalid': montoFijoValueInvalido }"
                  :required="producto.montoFijo"
                >
                <small v-if="montoFijoValueInvalido" class="field-error">
                  Monto fijo valor es obligatorio y debe ser mayor que 0.
                </small>
              </div>
              <template v-if="producto.montoLimiteActivo">
                <div class="form-field">
                  <label>Monto límite inferior</label>
                  <input
                    v-model.number="producto.montoLimInf"
                    type="number"
                    step="any"
                    class="form-control input-pad"
                    :required="producto.montoLimiteActivo"
                  >
                </div>
                <div class="form-field">
                  <label>Monto límite superior</label>
                  <input
                    v-model.number="producto.montoLimSup"
                    type="number"
                    step="any"
                    class="form-control input-pad"
                    :class="{ 'is-invalid': montoLimiteSuperiorInvalido }"
                    :required="producto.montoLimiteActivo"
                  >
                  <small v-if="montoLimiteSuperiorInvalido" class="field-error">
                    Monto limite superior es obligatorio y debe ser mayor que el monto limite inferior.
                  </small>
                </div>
              </template>
            </div>
          </div>

          <div class="section-block">
            <h5 class="section-title">Periodo de pago</h5>
            <div class="form-grid">
              <div class="form-field full-width">
                <div class="check-group">
                  <label v-for="periodo in periodosPago" :key="periodo" class="chip-check">
                    <input v-model="producto.periodoPago" type="checkbox" :value="periodo">
                    <span>{{ periodo }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="section-block">
            <h5 class="section-title">Tasa de interés</h5>
            <div class="form-grid">
              <div v-if="!producto.tasaInteresLimiteActivo" class="form-field switch-field">
                <label>Tasa de interés fijo</label>
                <input v-model="producto.tasaInteresFijo" type="checkbox" class="form-check-input" @change="handleTasaFijaChange">
              </div>
              <div v-if="!producto.tasaInteresFijo" class="form-field switch-field">
                <label>Tasa interés límite activo</label>
                <input v-model="producto.tasaInteresLimiteActivo" type="checkbox" class="form-check-input" @change="handleTasaLimiteChange">
              </div>
              <div v-if="producto.tasaInteresFijo" class="form-field">
                <label>Tasa interés fijo valor</label>
                <input
                  v-model.number="producto.tasaInteresFijoValue"
                  type="number"
                  step="any"
                  min="0.01"
                  class="form-control input-pad"
                  :class="{ 'is-invalid': tasaInteresFijoValueInvalido }"
                  :required="producto.tasaInteresFijo"
                >
                <small v-if="tasaInteresFijoValueInvalido" class="field-error">
                  Tasa interes fijo valor es obligatorio y debe ser mayor que 0.
                </small>
              </div>
              <template v-if="producto.tasaInteresLimiteActivo">
                <div class="form-field">
                  <label>Tasa interés límite inferior</label>
                  <input
                    v-model.number="producto.tasaInteresLimInf"
                    type="number"
                    step="any"
                    class="form-control input-pad"
                    :required="producto.tasaInteresLimiteActivo"
                  >
                </div>
                <div class="form-field">
                  <label>Tasa interés límite superior</label>
                  <input
                    v-model.number="producto.tasaInteresLimSup"
                    type="number"
                    step="any"
                    class="form-control input-pad"
                    :class="{ 'is-invalid': tasaInteresLimiteSuperiorInvalido }"
                    :required="producto.tasaInteresLimiteActivo"
                  >
                  <small v-if="tasaInteresLimiteSuperiorInvalido" class="field-error">
                    Tasa interes limite superior es obligatorio y debe ser mayor que la tasa interes limite inferior.
                  </small>
                </div>
              </template>
              <div class="form-field">
                <label>Tipo tasa interés</label>
                <select v-model="producto.tipoTasaInteres" class="form-select input-pad" required>
                  <option disabled value="">Selecciona una opción</option>
                  <option value="fija">fija</option>
                  <option value="variable">variable</option>
                  <option value="mixta">mixta</option>
                </select>
              </div>
            </div>
          </div>

          <div class="section-block">
            <h5 class="section-title">Tasa de inter&eacute;s moratorio</h5>
            <div class="form-grid">
              <div v-if="!producto.tasaMoraLimiteActivo" class="form-field switch-field">
                <label>Tasa de inter&eacute;s moratorio fijo</label>
                <input v-model="producto.tasaMoraFijo" type="checkbox" class="form-check-input" @change="handleTasaMoraFijaChange">
              </div>
              <div v-if="!producto.tasaMoraFijo" class="form-field switch-field">
                <label>Tasa inter&eacute;s moratorio l&iacute;mite activo</label>
                <input v-model="producto.tasaMoraLimiteActivo" type="checkbox" class="form-check-input" @change="handleTasaMoraLimiteChange">
              </div>
              <div v-if="producto.tasaMoraFijo" class="form-field">
                <label>Tasa inter&eacute;s moratorio fijo valor</label>
                <input
                  v-model.number="producto.tasaMoraFijoValue"
                  type="number"
                  step="any"
                  min="0.01"
                  class="form-control input-pad"
                  :class="{ 'is-invalid': tasaMoraFijoValueInvalido }"
                  :required="producto.tasaMoraFijo"
                >
                <small v-if="tasaMoraFijoValueInvalido" class="field-error">
                  Tasa interes moratorio fijo valor es obligatorio y debe ser mayor que 0.
                </small>
              </div>
              <template v-if="producto.tasaMoraLimiteActivo">
                <div class="form-field">
                  <label>Tasa moratorio l&iacute;mite inferior</label>
                  <input
                    v-model.number="producto.tasaMoraLimInf"
                    type="number"
                    step="any"
                    class="form-control input-pad"
                    :required="producto.tasaMoraLimiteActivo"
                  >
                </div>
                <div class="form-field">
                  <label>Tasa moratorio l&iacute;mite superior</label>
                  <input
                    v-model.number="producto.tasaMoraLimSup"
                    type="number"
                    step="any"
                    class="form-control input-pad"
                    :class="{ 'is-invalid': tasaMoraLimiteSuperiorInvalido }"
                    :required="producto.tasaMoraLimiteActivo"
                  >
                  <small v-if="tasaMoraLimiteSuperiorInvalido" class="field-error">
                    Tasa moratorio limite superior es obligatorio y debe ser mayor que la tasa moratorio limite inferior.
                  </small>
                </div>
              </template>
            </div>
          </div>

          <div class="section-block">
            <h5 class="section-title">Plazo</h5>
            <div class="form-grid">
              <div v-if="!producto.plazoLimiteActivo" class="form-field switch-field">
                <label>Plazo fijo</label>
                <input v-model="producto.plazoFijo" type="checkbox" class="form-check-input" @change="handlePlazoFijoChange">
              </div>
              <div v-if="!producto.plazoFijo" class="form-field switch-field">
                <label>Plazo límite activo</label>
                <input v-model="producto.plazoLimiteActivo" type="checkbox" class="form-check-input" @change="handlePlazoLimiteChange">
              </div>
              <div v-if="producto.plazoFijo" class="form-field">
                <label>Plazo fijo valor</label>
                <input
                  v-model.number="producto.plazoFijoValue"
                  type="number"
                  step="1"
                  min="1"
                  class="form-control input-pad"
                  :class="{ 'is-invalid': plazoFijoValueInvalido }"
                  :required="producto.plazoFijo"
                >
                <small v-if="plazoFijoValueInvalido" class="field-error">
                  Plazo fijo valor es obligatorio y debe ser mayor que 0.
                </small>
              </div>
              <template v-if="producto.plazoLimiteActivo">
                <div class="form-field">
                  <label>Plazo límite inferior</label>
                  <input
                    v-model.number="producto.plazoLimInf"
                    type="number"
                    step="1"
                    min="1"
                    class="form-control input-pad"
                    :required="producto.plazoLimiteActivo"
                  >
                </div>
                <div class="form-field">
                  <label>Plazo límite superior</label>
                  <input
                    v-model.number="producto.plazoLimSup"
                    type="number"
                    step="1"
                    min="1"
                    class="form-control input-pad"
                    :class="{ 'is-invalid': plazoLimiteSuperiorInvalido }"
                    :required="producto.plazoLimiteActivo"
                  >
                  <small v-if="plazoLimiteSuperiorInvalido" class="field-error">
                    Plazo limite superior es obligatorio y debe ser mayor que el plazo limite inferior.
                  </small>
                </div>
              </template>
            </div>
          </div>

          <div class="section-block">
            <h5 class="section-title">Comisión activa</h5>
            <div class="form-grid">
              <div class="form-field switch-field">
                <label>Comisión activa</label>
                <input v-model="producto.comisionActiva" type="checkbox" class="form-check-input" @change="handleComisionActivaChange">
              </div>
              <div v-if="producto.comisionActiva" class="form-field">
                <label>Tipo comisión</label>
                <select v-model="producto.tipoComision" class="form-select input-pad">
                  <option disabled value="">Selecciona una opción</option>
                  <option value="descontada">descontada</option>
                  <option value="financiada">financiada</option>
                  <option value="separada">separada</option>
                </select>
              </div>
              <div v-if="producto.comisionActiva" class="commission-list full-width">
                <div class="commission-list-header">
                  <label>Comisiones</label>
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="addComision">
                    Agregar comision
                  </button>
                </div>
                <div v-if="producto.comisiones.length === 0" class="commission-empty">
                  No hay comisiones agregadas.
                </div>
                <div
                  v-for="(comision, index) in producto.comisiones"
                  :key="comision.id || `comision-${index}`"
                  class="commission-row"
                >
                  <div class="commission-field">
                    <label>Nombre</label>
                    <input v-model.trim="comision.nombre" type="text" class="form-control input-pad">
                  </div>
                  <div class="commission-field">
                    <label>Porcentaje</label>
                    <input v-model.number="comision.porcentaje" type="number" min="0" step="any" class="form-control input-pad">
                  </div>
                  <button type="button" class="btn btn-sm btn-outline-danger" @click="removeComision(index)">
                    Borrar
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="section-block">
            <h5 class="section-title">Fecha fija</h5>
            <div class="form-grid">
              <div class="form-field switch-field">
                <label>Fecha otorgamiento día hoy</label>
                <input v-model="producto.fechaOtorgamientoDiaHoy" type="checkbox" class="form-check-input">
              </div>
              <div class="form-field switch-field">
                <label>Fecha fija activa</label>
                <input v-model="producto.fechaFijaActiva" type="checkbox" class="form-check-input">
              </div>
              <div v-if="producto.fechaFijaActiva" class="form-field switch-field">
                <label>Fecha fija value</label>
                <input v-model="producto.fechaFijaValue" type="checkbox" class="form-check-input">
              </div>
            </div>
          </div>

          <div class="section-block">
            <h5 class="section-title">Sin mora</h5>
            <div class="form-grid">
              <div class="form-field switch-field">
                <label>Sin mora activa</label>
                <input v-model="producto.sinMoraActiva" type="checkbox" class="form-check-input">
              </div>
              <div v-if="producto.sinMoraActiva" class="form-field switch-field">
                <label>Sin mora value</label>
                <input v-model="producto.sinMoraValue" type="checkbox" class="form-check-input">
              </div>
            </div>
          </div>

          <div class="section-block">
            <h5 class="section-title">Periodo de gracia</h5>
            <div class="form-grid">
              <div class="form-field switch-field">
                <label>Periodo gracia activo</label>
                <input v-model="producto.periodoGraciaActivo" type="checkbox" class="form-check-input">
              </div>
              <div v-if="producto.periodoGraciaActivo" class="form-field">
                <label>Periodo gracia value</label>
                <input v-model.number="producto.periodoGraciaValue" type="number" step="1" class="form-control input-pad">
              </div>
            </div>
          </div>

          </fieldset>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import Security from '../security';
import { store } from '../store';

export default {
  name: 'Crear-Producto',
  data() {
    return {
      saving: false,
      isAdmin: false,
      isEditMode: false,
      periodosPago: ['semanal', 'quincenal', 'mensual', 'al vencimiento', 'bimensual', 'trimestral', 'semestral', 'anual'],
      producto: {
        nombre: '',
        descripcion: '',
        activo: false,
        montoFijo: false,
        montoFijoValue: 0,
        montoLimiteActivo: false,
        montoLimSup: 0,
        montoLimInf: 0,
        periodoPago: [],
        tasaInteresFijo: false,
        tasaInteresFijoValue: 0,
        tasaInteresLimiteActivo: false,
        tasaInteresLimSup: 0,
        tasaInteresLimInf: 0,
        tipoTasaInteres: '',
        tasaMoraFijo: false,
        tasaMoraFijoValue: 0,
        tasaMoraLimiteActivo: false,
        tasaMoraLimSup: 0,
        tasaMoraLimInf: 0,
        comisionActiva: false,
        tipoComision: '',
        comisiones: [],
        plazoFijo: false,
        plazoFijoValue: 0,
        plazoLimiteActivo: false,
        plazoLimSup: 0,
        plazoLimInf: 0,
        fechaOtorgamientoDiaHoy: false,
        fechaFijaActiva: false,
        fechaFijaValue: false,
        sinMoraActiva: false,
        sinMoraValue: false,
        periodoGraciaActivo: false,
        periodoGraciaValue: 0,
        createUser: '',
      },
    };
  },
  computed: {
    actionButtonText() {
      if (this.saving) {
        return this.isEditMode ? 'Actualizando...' : 'Guardando...';
      }
      if (this.isEditMode) {
        return this.isAdmin ? 'Actualizar' : 'Solo lectura';
      }
      return 'Guardar producto';
    },
    montoFijoValueInvalido() {
      return this.producto.montoFijo
        && (!this.hasNumber(this.producto.montoFijoValue) || Number(this.producto.montoFijoValue) <= 0);
    },
    montoLimiteSuperiorInvalido() {
      if (!this.producto.montoLimiteActivo) {
        return false;
      }

      if (!this.hasNumber(this.producto.montoLimSup)) {
        return true;
      }

      if (!this.hasNumber(this.producto.montoLimInf)) {
        return true;
      }

      return Number(this.producto.montoLimSup) <= Number(this.producto.montoLimInf);
    },
    tasaInteresFijoValueInvalido() {
      return this.producto.tasaInteresFijo
        && (!this.hasNumber(this.producto.tasaInteresFijoValue) || Number(this.producto.tasaInteresFijoValue) <= 0);
    },
    tasaInteresLimiteSuperiorInvalido() {
      if (!this.producto.tasaInteresLimiteActivo) {
        return false;
      }

      if (!this.hasNumber(this.producto.tasaInteresLimSup)) {
        return true;
      }

      if (!this.hasNumber(this.producto.tasaInteresLimInf)) {
        return true;
      }

      return Number(this.producto.tasaInteresLimSup) <= Number(this.producto.tasaInteresLimInf);
    },
    tasaMoraFijoValueInvalido() {
      return this.producto.tasaMoraFijo
        && (!this.hasNumber(this.producto.tasaMoraFijoValue) || Number(this.producto.tasaMoraFijoValue) <= 0);
    },
    tasaMoraLimiteSuperiorInvalido() {
      if (!this.producto.tasaMoraLimiteActivo) {
        return false;
      }

      if (!this.hasNumber(this.producto.tasaMoraLimSup)) {
        return true;
      }

      if (!this.hasNumber(this.producto.tasaMoraLimInf)) {
        return true;
      }

      return Number(this.producto.tasaMoraLimSup) <= Number(this.producto.tasaMoraLimInf);
    },
    plazoFijoValueInvalido() {
      return this.producto.plazoFijo
        && (!this.hasNumber(this.producto.plazoFijoValue) || Number(this.producto.plazoFijoValue) <= 0);
    },
    plazoLimiteSuperiorInvalido() {
      if (!this.producto.plazoLimiteActivo) {
        return false;
      }

      if (!this.hasNumber(this.producto.plazoLimSup)) {
        return true;
      }

      if (!this.hasNumber(this.producto.plazoLimInf)) {
        return true;
      }

      return Number(this.producto.plazoLimSup) <= Number(this.producto.plazoLimInf);
    },
  },
  mounted() {
    const userRoles = Security.getUserRoles();
    this.isAdmin = userRoles[0]?.some((role) => role.includes('Admin')) === true;
    const productoId = this.$route?.query?.id;
    if (productoId) {
      this.isEditMode = true;
      this.fetchProductoByID(productoId);
    }
  },
  methods: {
    hasNumber(value) {
      return value !== '' && value !== null && value !== undefined && Number.isFinite(Number(value));
    },
    handleMontoFijoChange() {
      if (this.producto.montoFijo) {
        this.producto.montoLimiteActivo = false;
      }
    },
    handleMontoLimiteChange() {
      if (this.producto.montoLimiteActivo) {
        this.producto.montoFijo = false;
      }
    },
    handleTasaFijaChange() {
      if (this.producto.tasaInteresFijo) {
        this.producto.tasaInteresLimiteActivo = false;
      }
    },
    handleTasaLimiteChange() {
      if (this.producto.tasaInteresLimiteActivo) {
        this.producto.tasaInteresFijo = false;
      }
    },
    handleTasaMoraFijaChange() {
      if (this.producto.tasaMoraFijo) {
        this.producto.tasaMoraLimiteActivo = false;
      }
    },
    handleTasaMoraLimiteChange() {
      if (this.producto.tasaMoraLimiteActivo) {
        this.producto.tasaMoraFijo = false;
      }
    },
    handlePlazoFijoChange() {
      if (this.producto.plazoFijo) {
        this.producto.plazoLimiteActivo = false;
      }
    },
    handlePlazoLimiteChange() {
      if (this.producto.plazoLimiteActivo) {
        this.producto.plazoFijo = false;
      }
    },
    handleComisionActivaChange() {
      if (this.producto.comisionActiva) {
        if (!Array.isArray(this.producto.comisiones) || this.producto.comisiones.length === 0) {
          this.addComision();
        }
        return;
      }

      this.producto.tipoComision = '';
      this.producto.comisiones = [];
    },
    addComision() {
      if (!Array.isArray(this.producto.comisiones)) {
        this.producto.comisiones = [];
      }

      this.producto.comisiones.push({
        id: 0,
        idProducto: this.producto.id || 0,
        nombre: '',
        porcentaje: 0,
      });
    },
    removeComision(index) {
      this.producto.comisiones.splice(index, 1);
    },
    validarComisiones() {
      if (!this.producto.comisionActiva) {
        this.producto.tipoComision = '';
        this.producto.comisiones = [];
        return true;
      }

      if (!Array.isArray(this.producto.comisiones) || this.producto.comisiones.length === 0) {
        Swal.fire('Error', 'Agrega al menos una comision.', 'error');
        return false;
      }

      const comisiones = this.producto.comisiones.map((comision) => ({
        id: comision.id || 0,
        idProducto: this.producto.id || comision.idProducto || 0,
        nombre: (comision.nombre || '').trim(),
        porcentaje: comision.porcentaje === '' || comision.porcentaje === null || comision.porcentaje === undefined
          ? null
          : Number(comision.porcentaje),
      }));

      const invalidComision = comisiones.some((comision) => (
        !comision.nombre
        || comision.porcentaje === null
        || !Number.isFinite(comision.porcentaje)
        || comision.porcentaje < 0
      ));

      if (invalidComision) {
        Swal.fire('Error', 'Cada comision debe tener nombre y porcentaje valido.', 'error');
        return false;
      }

      this.producto.comisiones = comisiones;
      return true;
    },
    validarMontoProducto() {
      if (this.producto.montoFijo) {
        this.producto.montoLimiteActivo = false;

        if (this.montoFijoValueInvalido) {
          Swal.fire('Error', 'Monto fijo valor es obligatorio y debe ser mayor que 0.', 'error');
          return false;
        }
      }

      if (this.producto.montoLimiteActivo) {
        this.producto.montoFijo = false;

        if (!this.hasNumber(this.producto.montoLimInf)) {
          Swal.fire('Error', 'Monto limite inferior es obligatorio.', 'error');
          return false;
        }

        if (!this.hasNumber(this.producto.montoLimSup)) {
          Swal.fire('Error', 'Monto limite superior es obligatorio.', 'error');
          return false;
        }

        if (Number(this.producto.montoLimSup) <= Number(this.producto.montoLimInf)) {
          Swal.fire('Error', 'Monto limite superior debe ser mayor que monto limite inferior.', 'error');
          return false;
        }
      }

      return true;
    },
    validarTasaInteresProducto() {
      if (this.producto.tasaInteresFijo) {
        this.producto.tasaInteresLimiteActivo = false;

        if (this.tasaInteresFijoValueInvalido) {
          Swal.fire('Error', 'Tasa interes fijo valor es obligatorio y debe ser mayor que 0.', 'error');
          return false;
        }
      }

      if (this.producto.tasaInteresLimiteActivo) {
        this.producto.tasaInteresFijo = false;

        if (!this.hasNumber(this.producto.tasaInteresLimInf)) {
          Swal.fire('Error', 'Tasa interes limite inferior es obligatorio.', 'error');
          return false;
        }

        if (!this.hasNumber(this.producto.tasaInteresLimSup)) {
          Swal.fire('Error', 'Tasa interes limite superior es obligatorio.', 'error');
          return false;
        }

        if (Number(this.producto.tasaInteresLimSup) <= Number(this.producto.tasaInteresLimInf)) {
          Swal.fire('Error', 'Tasa interes limite superior debe ser mayor que tasa interes limite inferior.', 'error');
          return false;
        }
      }

      return true;
    },
    validarTasaMoraProducto() {
      if (this.producto.tasaMoraFijo) {
        this.producto.tasaMoraLimiteActivo = false;

        if (this.tasaMoraFijoValueInvalido) {
          Swal.fire('Error', 'Tasa interes moratorio fijo valor es obligatorio y debe ser mayor que 0.', 'error');
          return false;
        }
      }

      if (this.producto.tasaMoraLimiteActivo) {
        this.producto.tasaMoraFijo = false;

        if (!this.hasNumber(this.producto.tasaMoraLimInf)) {
          Swal.fire('Error', 'Tasa moratorio limite inferior es obligatorio.', 'error');
          return false;
        }

        if (!this.hasNumber(this.producto.tasaMoraLimSup)) {
          Swal.fire('Error', 'Tasa moratorio limite superior es obligatorio.', 'error');
          return false;
        }

        if (Number(this.producto.tasaMoraLimSup) <= Number(this.producto.tasaMoraLimInf)) {
          Swal.fire('Error', 'Tasa moratorio limite superior debe ser mayor que tasa moratorio limite inferior.', 'error');
          return false;
        }
      }

      return true;
    },
    validarPlazoProducto() {
      if (this.producto.plazoFijo) {
        this.producto.plazoLimiteActivo = false;

        if (this.plazoFijoValueInvalido) {
          Swal.fire('Error', 'Plazo fijo valor es obligatorio y debe ser mayor que 0.', 'error');
          return false;
        }
      }

      if (this.producto.plazoLimiteActivo) {
        this.producto.plazoFijo = false;

        if (!this.hasNumber(this.producto.plazoLimInf)) {
          Swal.fire('Error', 'Plazo limite inferior es obligatorio.', 'error');
          return false;
        }

        if (!this.hasNumber(this.producto.plazoLimSup)) {
          Swal.fire('Error', 'Plazo limite superior es obligatorio.', 'error');
          return false;
        }

        if (Number(this.producto.plazoLimSup) <= Number(this.producto.plazoLimInf)) {
          Swal.fire('Error', 'Plazo limite superior debe ser mayor que plazo limite inferior.', 'error');
          return false;
        }
      }

      return true;
    },
    fetchProductoByID(productoId) {
      const endpoints = [`/productos/${productoId}`, `/admin/productos/${productoId}`];
      this.fetchProductoByIDFromEndpoints(endpoints, 0);
    },
    fetchProductoByIDFromEndpoints(endpoints, index) {
      if (index >= endpoints.length) {
        Swal.fire('Error', 'No se pudo cargar el producto', 'error');
        return;
      }
      const headers = new Headers();
      headers.append('Authorization', 'Bearer ' + store.token);
      fetch(process.env.VUE_APP_API_URL + endpoints[index], { method: 'GET', headers })
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.fetchProductoByIDFromEndpoints(endpoints, index + 1);
            return;
          }
          const producto = response.data?.producto || response.data;
          if (!producto) {
            this.fetchProductoByIDFromEndpoints(endpoints, index + 1);
            return;
          }
          this.producto = {
            ...this.producto,
            ...producto,
            periodoPago: Array.isArray(producto.periodoPago) ? producto.periodoPago : [],
            comisiones: Array.isArray(producto.comisiones) ? producto.comisiones : [],
          };
          if (this.producto.comisionActiva && this.producto.comisiones.length === 0) {
            this.addComision();
          }
        })
        .catch(() => {
          this.fetchProductoByIDFromEndpoints(endpoints, index + 1);
        });
    },
    guardarProducto() {
      if (!this.validarMontoProducto()) {
        return;
      }

      if (!this.validarTasaInteresProducto()) {
        return;
      }

      if (!this.validarTasaMoraProducto()) {
        return;
      }

      if (!this.validarPlazoProducto()) {
        return;
      }

      if (!this.validarComisiones()) {
        return;
      }

      if (this.isEditMode) {
        if (!this.isAdmin) {
          Swal.fire('Info', 'Solo un usuario Admin puede actualizar productos.', 'info');
          return;
        }
        this.actualizarProducto();
        return;
      }
      this.saving = true;
      fetch(process.env.VUE_APP_API_URL + '/admin/productos/save', Security.requestOptions(this.producto))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            Swal.fire('Error', response.message, 'error');
            return;
          }
          Swal.fire('Éxito', 'Producto creado correctamente', 'success');
          this.$router.push('/productos');
        })
        .catch((error) => {
          this.$emit('error', error);
          Swal.fire('Error', 'No se pudo guardar el producto', 'error');
        })
        .finally(() => {
          this.saving = false;
        });
    },
    actualizarProducto() {
      this.saving = true;
      const endpoints = ['/productos/update', '/admin/productos/update'];
      this.actualizarProductoFromEndpoints(endpoints, 0);
    },
    actualizarProductoFromEndpoints(endpoints, index) {
      if (index >= endpoints.length) {
        this.saving = false;
        Swal.fire('Error', 'No se pudo actualizar el producto', 'error');
        return;
      }
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', 'Bearer ' + store.token);
      fetch(process.env.VUE_APP_API_URL + endpoints[index], {
        method: 'PUT',
        body: JSON.stringify(this.producto),
        headers,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.actualizarProductoFromEndpoints(endpoints, index + 1);
            return;
          }
          Swal.fire('Éxito', 'Producto actualizado correctamente', 'success');
          this.$router.push('/productos');
        })
        .catch(() => {
          this.actualizarProductoFromEndpoints(endpoints, index + 1);
        })
        .finally(() => {
          if (index === endpoints.length - 1) {
            this.saving = false;
          }
        });
    },
  },
};
</script>

<style scoped>
.producto-shell {
  background: linear-gradient(160deg, #f4f7ff 0%, #eef3fb 55%, #f8fbff 100%);
  min-height: 100vh;
  padding: 24px;
}

.producto-card {
  background: #fff;
  border: 1px solid #e6ebf2;
  border-radius: 20px;
  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.08);
  padding: 24px;
}

.producto-header {
  background: linear-gradient(120deg, #0f172a 0%, #1f2937 70%, #374151 100%);
  color: #fff;
  border-radius: 16px;
  padding: 18px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.section-block {
  margin-bottom: 18px;
  border: 1px solid #e8edf5;
  border-radius: 14px;
  padding: 14px;
  background: #fcfdff;
}

.section-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 12px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-field label {
  font-weight: 600;
  color: #334155;
}

.field-error {
  color: #dc3545;
  font-size: 0.84rem;
  line-height: 1.35;
}

.switch-field {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.input-pad {
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
}

.full-width {
  grid-column: 1 / -1;
}

.commission-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.commission-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.commission-list-header label,
.commission-field label {
  font-weight: 600;
  color: #334155;
}

.commission-empty {
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  color: #64748b;
  padding: 12px;
  background: #f8fafc;
}

.commission-row {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(120px, 0.7fr) auto;
  gap: 12px;
  align-items: end;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  background: #fff;
}

.commission-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.check-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.chip-check {
  border: 1px solid #dbe3ef;
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f8fafc;
}

@media (max-width: 992px) {
  .form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .producto-shell {
    padding: 12px;
  }

  .producto-card {
    padding: 14px;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .commission-row {
    grid-template-columns: 1fr;
  }
}
</style>
